<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容："  label-for="key">
              <Input search enter-button placeholder="请输入物品名称/库存批次号搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选仓库："  label-for="key">
              <Select v-model="filter.warehouse_id" placeholder="请选择仓库" @on-change="select">
                <Option value="0">全部</Option>
                <Option v-for="(name, id) in warehouseList" :value="id" :key="id">{{ name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="库存类型："  label-for="key">
              <Select v-model="filter.type" placeholder="请选择库存类型" @on-change="select">
                <Option value="0">全部</Option>
                <Option value="1">基地库存</Option>
                <Option value="2">三方库存</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="盘点状态："  label-for="key">
              <Select v-model="filter.check_status" placeholder="请选择盘点状态" @on-change="select">
                <Option :value="-1">全部</Option>
                <Option :value="0">正常</Option>
                <Option :value="1">盘盈</Option>
                <Option :value="2">盘亏</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>

  </div>
</template>

<script>
import {
  warehouseInventoryCheckListApi
} from '@/api/warehouse/warehouseInventoryCheck'
import {warehouseAllApi} from "@/api/warehouse/warehouse";

export default {
  name: 'warehouseInventoryCheckList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        search: '',
        warehouse_id: '0',
        check_status: -1,
        type: '0',
        ctime: [],
      },
      warehouseList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '库存批次号',
          key: 'warehouse_inventory_batch_sn',
          minWidth: 200
        },
        {
          title: '库存类型',
          key: 'type_msg',
          minWidth: 120
        },
        {
          title: '仓库名称',
          key: 'warehouse_name',
          minWidth: 120
        },
        {
          title: '物品名称',
          key: 'goods_name',
          minWidth: 160
        },
        {
          title: '存放区域',
          key: 'location',
          minWidth: 180
        },
        {
          title: '库存数量',
          key: 'expected_num',
          minWidth: 100
        },
        {
          title: '盘点数量',
          key: 'actual_num',
          minWidth: 100
        },
        {
          title: '盘点差异',
          minWidth: 100,
          render: (h, params) => {
            let style = {};
            let difference = params.row.difference;

            if (params.row.check_status === 0) {
              return h('div', difference);
            } else if (params.row.check_status === 1) {
              style = { color: 'red' };
              difference = '+' + difference;
            } else if (params.row.check_status === 2) {
              style = { color: 'green' };
              difference = '-' + difference;
            }

            return h('div', { style: style }, difference);
          }
        },
        {
          title: '单位',
          key: 'unit',
          minWidth: 100
        },
        {
          title: '盘点状态',
          key: 'check_status_msg',
          minWidth: 150
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 180
        },
        {
          title: '盘点时间',
          key: 'check_time',
          minWidth: 180
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
      ]
    }
  },
  created () {
    this.loadWarehouseList()
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      warehouseInventoryCheckListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 清空搜索
    searchClear () {
      this.filter.search = ''
      this.filter.page = 1
      this.loadTableData()
    },
    // 下拉选择
    select (status) {
      this.filter.page = 1
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 加载仓库
    loadWarehouseList() {
      warehouseAllApi().then(res => {
        //数据赋值
        this.warehouseList = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
